import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useParams } from "react-router-dom";
import TokenForm from "../components/TokenForm/TokenForm"; // Adjust path if needed

const ClubDetailPage = () => {
  const { clubname } = useParams();
  const { t } = useContext(LanguageContext);
  const [club, setClub] = useState(null);
  const [donors, setDonors] = useState([]);
  const [totalDonations, setTotalDonations] = useState(0);
  const [totalTokens, setTotalTokens] = useState(0);
  const [loading, setLoading] = useState(true);

  const formatEuro = (amount) => {
    return amount?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  const formatDate = (dateString) => {
    if (!dateString) return t('_club.dateNotProvided');
    return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  useEffect(() => {
    const fetchClubAndDonations = async () => {
      try {
        const resClub = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clubs/byname/${clubname}`);
        const clubData = await resClub.json();
        if (!resClub.ok) throw new Error(clubData.message || t('_club.clubNotFound'));

        setClub(clubData);

        const resDonations = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clubs/donations/${clubData.id}`);
        const { donors, total } = await resDonations.json();
        setDonors(donors);
        setTotalDonations(parseFloat(total || 0));

        // Manually sum tokens
        const totalTokens = donors.reduce((sum, d) => sum + (Number(d.tokens) || 0), 0);
        setTotalTokens(totalTokens);

      } catch (err) {
        console.error("Error loading club:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClubAndDonations();
  }, [clubname, t]);

  if (loading) return <p className="text-center mt-10">{t('_club.loading')}</p>;
  if (!club) return <p className="text-center mt-10 text-red-600">{t('_club.clubNotFound')}</p>;

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row gap-10">

        {/* Left - Club Details */}
        <div className="md:w-2/3 bg-white rounded-2xl shadow-lg p-8 space-y-10 animate-fadeIn">
          {/* Club Header */}
          <div className="flex items-center gap-6 border-b pb-6">
            {club.logo && (
              <img src={`${process.env.REACT_APP_API_BASE_URL}${club.logo}`} alt={club.name} className="w-24 h-24 object-cover rounded-full border-2 border-gray-300" />
            )}
            <div className="flex flex-col md:flex-row md:items-center md:gap-4">
  <h1 className="text-3xl font-bold text-gray-800">{club.name}</h1>
  <span className="text-sm text-gray-500 mt-1 md:mt-0">
    {t('_club.totalDonations')}:{" "}
    <span className="text-green-600 font-semibold">
      {formatEuro(totalDonations)} 
    </span>
  </span>
</div>
          </div>
          <TokenForm hideClubSelector={true} defaultClubId={club.id} />
        </div>
        

        {/* Right - Donor Wall */}
        <div className="md:w-1/3 bg-white shadow-md rounded-xl p-5 h-fit animate-fadeIn">
        <h2 className="text-xl font-semibold mb-4">{t('_club.recentDonors')}</h2>
          {donors.length === 0 ? (
            <p className="text-gray-500">{t('_club.noDonationsYet')}</p>
          ) : (
            <ul className="space-y-4">
              {donors.map((d, index) => (
                <li
                  key={index}
                  className={`flex items-center justify-between p-4 rounded-xl border ${
                    d.amount > 300 ? 'bg-yellow-50 border-yellow-300' : 'bg-white border-gray-200'
                  } hover:shadow-lg hover:scale-[1.02] transition-all duration-300`}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-blue-500 flex items-center justify-center text-white font-bold text-lg shadow-sm">
                      {d.name?.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div className="font-semibold text-gray-800 text-md">
                          {d.is_special === 1 && d.company ? d.company : d.name}
                      </div>
                      
                    </div>
                  </div>
                  <div className="text-green-600 font-bold text-md text-right whitespace-nowrap flex-shrink-0">
                    {formatEuro(parseFloat(d.amount))}                    
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClubDetailPage;
